import AppStateContext from "contexts/AppStateContext";
import { useContext } from "react";

export const useAppState = () => useContext(AppStateContext);
